// @ts-nocheck
import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from "../../../../../stores/mobx-compat";

import Modal, { ModalActions } from '../../../../ui/Modal';
import FormGroup from '../../../../ui/FormGroup';
import Input from '../../../../ui/Input';
import { GlobeIcon } from '../../../../ui/icons';

const SUBDOMAIN_RE = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)*[a-zA-Z0-9][a-zA-Z0-9-_]*\.[a-zA-Z]{1,11}?$/;

class AddEmailDomain extends Component {
  defaultState = { emailDomain: '', validEmailDomain: true };
  state = this.defaultState;

  test = _.debounce((emailDomain) => {
    this.setState({ validEmailDomain: SUBDOMAIN_RE.test(emailDomain) });
  }, 700);

  handleInput = (e) => {
    this.setState({ emailDomain: e.target.value });
    this.test(e.target.value);
  };

  cancel = () => {
    this.setState(this.defaultState);
    this.props.onClose();
  };

  render() {
    const { addEmailDomain, loading } = this.props.store.emailManagement;
    return (
      <Modal
        open={this.props.open}
        onClose={this.cancel}
        title="Add email domain"
        icon={GlobeIcon}
        sub="We'll set up DNS records so we can send from your domain."
        actions={(
          <ModalActions
            onCancel={this.cancel}
            onConfirm={async () => {
              await addEmailDomain({ emailDomain: this.state.emailDomain });
              this.cancel();
            }}
            confirmLabel="Add domain"
            confirmLoading={loading.addEmailDomain}
            confirmDisabled={loading.addEmailDomain || !this.state.validEmailDomain || !this.state.emailDomain}
          />
        )}
      >
        <FormGroup
          label="Domain"
          error={!this.state.validEmailDomain
            ? 'Accepted formats: example.com, rap.example.com, test-test.rap.example.com'
            : null}
        >
          <Input
            placeholder="rap.example.com"
            value={this.state.emailDomain}
            onChange={this.handleInput}
            invalid={!this.state.validEmailDomain}
          />
        </FormGroup>
      </Modal>
    );
  }
}

export default inject('store')(observer(AddEmailDomain));
